import Caption from 'LuxKit/Typography/Caption'

interface Props {
  location?: string
}

function ExperienceLocationCaption({ location }: Props) {
  return (
    <Caption variant="large" lineClamp={1}>
      {location && <Caption as="span" variant="large" colour="neutral-two">{location}</Caption>}
    </Caption>
  )
}

export default ExperienceLocationCaption
